import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Note {
  id: number;
  examName: string;
  creationDate: string;
  description: string;
  noteMax: string;
  noteMin: string;
  vu: string;
}

export interface ApiResponseNotes {
  error: string;
  response: Note[];
}

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  private baseUrl = environment.apiUrl + '/note/listNoteByStudent';

  constructor(private http: HttpClient) { }

  getNotes(idStudent: number, idOrg: number): Observable<ApiResponseNotes> {
    const url = `${this.baseUrl}/${idStudent}/${idOrg}`;
    return this.http.get<ApiResponseNotes>(url);
  }

}
